import React from 'react';
import { t, } from '../../../jsCore/providers/i18nProvider/i18nProvider';
const blockName = 'show-more-button';
export default function ShowMoreButton({ leagueId, scoresBaseUrl, }){
  const scoresUrl = `${ scoresBaseUrl }?initialLeagueId=${ leagueId }`;
  const textViewAllGames = t('homepage.view_all');
  return (
    <div className={ blockName }>
      <a
        className={ `${ blockName }__button` }
        href={ scoresUrl }
        title={ textViewAllGames }
      >
      { textViewAllGames }
      </a>
    </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/showMoreButton.js